import usersApi from '@/api/identity/usersApi'
import { ChangeMyProfilePayload } from '@/types/user'
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'

async function editUserProfile(payload: ChangeMyProfilePayload): Promise<void> {
  await usersApi.changeProfile(payload)
}

function useUpdateUserProfile(): UseMutateFunction<
  void,
  unknown,
  ChangeMyProfilePayload,
  unknown
> {
  const queryClient = useQueryClient()

  const { mutate } = useMutation(
    (payload: ChangeMyProfilePayload) => editUserProfile(payload),
    {
      onSuccess: () => {
        window.location.reload()
      },
      onError: (error) => {
        // toast.error(error)
      },
    },
  )

  return mutate
}

export default useUpdateUserProfile
